import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!email || !password) {
      setError("Please fill in all fields");
      setLoading(false);
      return;
    }

    const result = await login(email, password);

    if (result.success) {
      navigate("/");
    } else {
      setError(result.error || "Login failed. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-inner">
        {/* Left side text */}
        <div className="auth-left">
          <h1 className="auth-title">Welcome back!</h1>
          <p className="auth-subtitle">
            Login to your account using your email and password.
          </p>
          <p className="auth-small">
            Don&apos;t have an account?{" "}
            <Link to="/register">Register for free.</Link>
          </p>

          <blockquote className="auth-quote">
            “I started investing at the age of 11. I was late!”
            <br />
            <span>Warren Buffett</span>
          </blockquote>
        </div>

        {/* Right side card */}
        <div className="auth-card">
          {/* <button type="button" className="auth-google-btn">
            Login using Google
          </button>

          <div className="auth-divider">
            <span>or using email</span>
          </div> */}

          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="auth-error">{error}</div>}

            <label className="auth-label">
              Email
              <input
                type="email"
                className="auth-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </label>

            <label className="auth-label">
              Password
              <input
                type="password"
                className="auth-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Your password"
                required
              />
            </label>

            <button
              type="submit"
              className="auth-primary-btn"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            {/* <div className="auth-small right">
              <button type="button" className="linklike">
                Lost password?
              </button>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
